import { z } from 'zod';

/**
 * Schema for AI-generated category suggestion response.
 *
 * Used by ai-agents.service.ts suggestCategoria() method to validate
 * structured output from the AI model.
 */
export const CategorySuggestionSchema = z.object({
  /** UUID of the suggested segment value (Category) */
  segmentValueId: z.string().uuid(),
  /** Short description for the bill (max 120 chars) */
  description: z.string().max(120),
});

/**
 * Type for category suggestion response
 */
export type CategorySuggestion = z.infer<typeof CategorySuggestionSchema>;

/**
 * @deprecated Use `CategorySuggestionSchema`
 */
export const CategoriaSuggestionSchema = CategorySuggestionSchema;

/**
 * @deprecated Use `CategorySuggestion`
 */
export type CategoriaSuggestion = CategorySuggestion;

